module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Modal":{"close":{"ariaLabel":"Zavřít"}}}}')
  delete Component.options._Ctor
}
